const COLORS = {
  defaultColor: '#2C1E4A',
  submit: '#5823C8',
};

export default COLORS;
